<template>
    <div v-if="showBlandRecording" class="fixed top-0 left-0 h-full w-full z-50 flex flex-column items-center justify-center" style="background-color: rgba(0,0,0,.2);">
        <div class="w-full bg-white rounded-lg mx-6" style="max-width: 92%; max-height: 100%;">

            <div class="p-6" style="position: relative; height: calc(100% - 20px); overflow: auto;">

            <div class="float-right -mb-4" style="position: relative;">
                <!-- <a href="https://www.bland.ai/" class="text-xs" target="lsa-bland-link">Sign Up for Bland</a> -->
            </div>

            <div style="clear: both;"></div>

            <div>
                <div v-if="loading_bland_recording" :class="'w-full mb-3'">
                    <v-skeleton-loader type="article, article, article"></v-skeleton-loader>
                </div>
                <div class="flex flex-row flex-wrap" v-else>
                    <div class="w-full mb-4">
                        <!-- <iframe :src="bland_recording_data.recording_url" style="width: 100%; height: 500px; border: 0px;"></iframe> -->
                        <div id="bl-audio-el-here"></div>
                    </div>
                    <div class="w-full">
                        <div id="ai-dialog-messages-list"  style="max-height: 500px; overflow: auto;">

                            <div v-if="!bland_recording_data.transcription" class="text-sm" style="text-align: center;">
                                <br />
                                No transcription available.
                            </div>
                            <div v-else>
                                <div>
                                    <b-list-group>
                                        <b-list-group-item
                                            v-for="(item, index) in bland_recording_data.transcription.messages" :key="index"
                                        
                                                    class="d-flex align-items-center mb-4 pb-4"
                                                    style="border: none; border-bottom: solid 1px #ededed;"
                                            >
                                                <b-avatar v-if="item.participant_type == 2 || item.sender == 'bot'"
                                                        text="S1"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <b-avatar v-if="item.participant_type == 3 || item.sender == 'human'"
                                                        text="S2"
                                                        class="mr-3 call-info-avatar"
                                                ></b-avatar>
                                                <div>
                                                    <span v-if="item.participant_type == 2 && item.sender != 'bot'" class="mr-auto primary-color text-bold">Advertiser</span>
                                                    <span v-if="(item.participant_type == 2 && item.sender == 'bot') || (item.participant_type == 2 || item.sender == 'bot')" class="mr-auto primary-color text-bold">AI Agent</span>
                                                    <span v-if="item.participant_type == 3 || item.sender == 'human'" class="mr-auto warning-color text-bold">Customer</span>

                                                    <span class="mr-auto text-xs text-gray-600"> . {{ displayTimestamp(item.event_time) }} . </span>
                                                    <div class="text-sm" v-html="showTextContents(item.text || item.body)"></div>
                                                </div>
                                            </b-list-group-item>
                                    </b-list-group>
                                </div>
                            </div>
                        </div>

                        <div v-show="bland_recording_data.transcription.messages && isMessage()" class="mt-4 -mb-12">
                            <v-text-field
                                clearable
                                outlined
                                dense
                                hide-details
                                label="Reply"
                                v-model="new_ai_message"

                                class="white border border-white"
                            ></v-text-field>
                        </div>
                    </div>
                </div>
            </div>

            </div>

            <div v-show="isMessage()" v-if="!loading_bland_recording" class="bg-gray-100 rounded-b-lg px-6 py-4">

                <button
                        class="rg-dialog-button-save custom-button rounded bg-gray-500 hover:bg-gray-600 text-white focus:outline-none py-2 px-4 float-left"
                        :class="{ spinner: sendingAiMessage }"
                        @click="sendAiReply()"
                        :disabled="!new_ai_message"
                >
                    SEND
                </button>

                <div style="float: right; padding-right: 30px; padding-top: 6px;">
                    <v-switch color="#48bb78" inset dense hide-details :ripple="false" v-model="ai_messages_lead.ai_enabled" label="AI Response Enabled" @change="switchAiResponseEnabled(ai_messages_lead);"></v-switch>
                </div>

                <div class="clearfix"></div>

            </div>

        </div>
    </div>
</template>

<script>

import { mapState } from 'vuex'
import axios from 'axios'
import moment from 'moment'

export default {
    computed: {
      ...mapState({
          // me: (state) => state.me.me,
          // profile: (state) => state.me.profile,
      }),
    },
data() {
    return {
        showBlandRecording: true,
        loading_bland_recording: true,
        bland_recording_data: {},

        new_ai_message: "",
        sendingAiMessage: false,
        ai_messages_lead: null,

        timezone: "America_New_York",
        
    }
},

methods: {
    showTextContents(data) {
        if (data.indexOf("Message: ") != -1) {
            return data.split("Message: ")[1];
        }

        return data;
    },
    isMessage() {
        return this.bland_recording_data && this.bland_recording_data.transcription && this.bland_recording_data.transcription.messages && !this.bland_recording_data.transcription.messages[0].speaker;
    },
    
    async switchAiResponseEnabled(lead) {
        console.log('lead', lead);

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/set-ai-response-enabled`, {
            lead_id: lead.id,
            ai_enabled: lead.ai_enabled
        }, {
            headers: {
                'RG-Auth-Loc-Uu': this.$route.query.u
            }
        });

        console.log('response', response);
    },

    async sendAiReply() {
        this.sendingAiMessage = true;
        
        let self = this;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/reply-ai-message`, {
            lead_id: self.ai_messages_lead.id,
            message: self.new_ai_message
        }, {
            headers: {
                'RG-Auth-Loc-Uu': this.$route.query.u
            }
        });

        let timezone = this.timezone;

        this.bland_recording_data.transcription.messages.push({
            created_at: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
            event_time: moment.tz(timezone).format("YYYY-MM-DD hh:mm:ss"),
            is_bland: 1,
            is_person: 1,
            sender: 'human',
            message: self.new_ai_message,
            text: self.new_ai_message
        });

        this.sendingAiMessage = false;
        this.new_ai_message = "";

        setTimeout(function() {
            var objDiv = document.getElementById("ai-dialog-messages-list");
            objDiv.scrollTop = objDiv.scrollHeight;
        }, 10);
    },

    displaySpeakerTimestamp(milliseconds) {
          //Get hours from milliseconds
          var hours = milliseconds / (1000*60*60);
          var absoluteHours = Math.floor(hours);
          var h = absoluteHours > 9 ? absoluteHours : '0' + absoluteHours;

          //Get remainder from hours and convert to minutes
          var minutes = (hours - absoluteHours) * 60;
          var absoluteMinutes = Math.floor(minutes);
          var m = absoluteMinutes > 9 ? absoluteMinutes : '0' +  absoluteMinutes;

          //Get remainder from minutes and convert to seconds
          var seconds = (minutes - absoluteMinutes) * 60;
          var absoluteSeconds = Math.floor(seconds);
          var s = absoluteSeconds > 9 ? absoluteSeconds : '0' + absoluteSeconds;


          return h + ':' + m + ':' + s;
    },

    async showBlandRecordingFunction(item) {
        this.ai_messages_lead = {
            id: this.$route.query.l
        };

        let self = this;

        this.showBlandRecording = true;
        this.loading_bland_recording = true;

        let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-bland-transcript`, {
            lead_id: this.$route.query.l
        }, {
            headers: {
                'RG-Auth-Loc-Uu': this.$route.query.u
            }
        });

        this.bland_recording_data.transcription = response.data.transcription;

        let original_ai_messages = JSON.parse(JSON.stringify(this.bland_recording_data.transcription));
        original_ai_messages = original_ai_messages.messages;

        console.log('original_ai_messages', original_ai_messages);

        if (1) {
            let response = await axios.post(`${process.env.VUE_APP_API_ENDPOINT}/call-tracking/get-lsa-messages`, {
                lead_id: this.$route.query.l
            }, {
                headers: {
                    'Authorization': 'Bearer ' + this.$store.state.auth.jwt
                }
            });

            for (var i in response.data.lsa_messages) {
                response.data.lsa_messages[i].sender = ((response.data.lsa_messages[i].participant_type == 3) ? "human" : "bot");
                response.data.lsa_messages[i].is_bland = ((response.data.lsa_messages[i].participant_type == 3) ? 0 : 1);
                response.data.lsa_messages[i].is_person = response.data.lsa_messages[i].is_bland;
                response.data.lsa_messages[i].timestamp = response.data.lsa_messages[i].event_time;
                response.data.lsa_messages[i].message = response.data.lsa_messages[i].text;

                for (var j in original_ai_messages) {
                    console.log('compare 1:', response.data.lsa_messages[i].message);
                    console.log('compare 2:', original_ai_messages[j].body);
                    if (response.data.lsa_messages[i].message == original_ai_messages[j].body) {

                        console.log("FOUD AI MESSAGE");
                        console.log(response.data.lsa_messages[i].message);
                        response.data.lsa_messages[i].is_person = 0;
                        break;
                    }
                }
            }

            if (response.data.lsa_messages.length > 0)
                this.bland_recording_data.transcription.messages = response.data.lsa_messages;
        }

        console.log('this.bland_recording_data.transcription.messages', this.bland_recording_data.transcription.messages);

        this.loading_bland_recording = false;
        
        if (response.data.timezone)
            this.timezone = response.data.timezone;

        if (response.data.ai_enabled == 1)
            this.ai_messages_lead.ai_enabled = true;
        else
            this.ai_messages_lead.ai_enabled = false;

        setTimeout(function() {
            var objDiv = document.getElementById("ai-dialog-messages-list");
            objDiv.scrollTop = objDiv.scrollHeight;
        }, 10);
    },

    formatDate: function(date, format = "MM/DD/YYYY") {
        return moment(String(date)).format(format)
    },

    displayTimestamp(date) {
        let timezone = this.timezone;

        // .tz(timezone)
        return moment.utc(date).format('ddd M/D YYYY h:mm:ss A');
    },

    displayDuration(seconds) {
        return date;
    },

    displayDuration(time) {
        var sec_num = time // don't forget the second param
        var hours   = Math.floor(sec_num / 3600);
        var minutes = Math.floor((sec_num - (hours * 3600)) / 60);
        var seconds = sec_num - (hours * 3600) - (minutes * 60);

        if (hours   < 10) {hours   = "0"+hours;}
        if (minutes < 10) {minutes = "0"+minutes;}
        if (seconds < 10) {seconds = "0"+seconds;}
        return hours+':'+minutes+':'+seconds;
    },

    formatPhoneNumber(phoneNumberString) {
        const match = phoneNumberString
.replace(/\D+/g, '').replace(/^1/, '')
.match(/([^\d]*\d[^\d]*){1,10}$/)[0]
const part1 = match.length > 2 ? `(${match.substring(0,3)})` : match
const part2 = match.length > 3 ? ` ${match.substring(3, 6)}` : ''
const part3 = match.length > 6 ? `-${match.substring(6, 10)}` : ''    
return `${part1}${part2}${part3}`
    },
},

created() {
    let self = this
    self.showBlandRecordingFunction();

    // self.getMessages();
    // self.loadCustomTags();
    // self.loadCustomStatuses();

    // this.thisProc = setInterval(function() {
    //     self.getMessages(true);
    // }, 5000);
},
}
</script>


<style scoped>

</style>
